var HumeCartRules = (function () {
  'use strict';

  var BAND_FAMILY = ['band', 'band_lw'];
  var POD1_FAMILY = ['pod1', 'pod1_lw'];
  var POD2_FAMILY = ['pod2', 'pod2_lw'];
  var WARRANTY_ROLES = ['band_w', 'pod1_w', 'pod2_w', 'w_band_pod1', 'w_band_pod2', 'w_2band', 'w_2pod1'];

  var ROWS = [
    ['A1', { band: 1 }, 'band_w', 'pod2'],
    ['A2', { band: 1, band_w: 1 }, null, 'pod2'],
    ['A3', { band_lw: 1 }, null, 'pod2'],
    ['B1', { pod1: 1 }, 'pod1_w', 'band'],
    ['B2', { pod1: 1, pod1_w: 1 }, null, 'band'],
    ['B3', { pod1_lw: 1 }, null, 'band'],
    ['B4', { pod2: 1 }, 'pod2_w', 'band'],
    ['B5', { pod2: 1, pod2_w: 1 }, null, 'band'],
    ['B6', { pod2_lw: 1 }, null, 'band'],
    ['C1', { band: 1, pod1: 1 }, 'w_band_pod1', null],
    ['C2', { band: 1, pod1: 1, w_band_pod1: 1 }, null, null],
    ['C3', { band: 1, pod1: 1, band_w: 1 }, 'pod1_w', null],
    ['C4', { band: 1, pod1: 1, pod1_w: 1 }, 'band_w', null],
    ['C5', { band: 1, pod1: 1, band_w: 1, pod1_w: 1 }, null, null],
    ['C6', { band_lw: 1, pod1: 1 }, 'pod1_w', null],
    ['C7', { band_lw: 1, pod1: 1, pod1_w: 1 }, null, null],
    ['C8', { band: 1, pod1_lw: 1 }, 'band_w', null],
    ['C9', { band: 1, band_w: 1, pod1_lw: 1 }, null, null],
    ['C10', { band_lw: 1, pod1_lw: 1 }, null, null],
    ['D1', { bundle: 1 }, 'w_band_pod1', null],
    ['D2', { bundle: 1, w_band_pod1: 1 }, null, null],
    ['D3', { bundle: 1, band_w: 1 }, 'pod1_w', null],
    ['D4', { bundle: 1, pod1_w: 1 }, 'band_w', null],
    ['D5', { bundle: 1, band_w: 1, pod1_w: 1 }, null, null],
    ['E1', { band: 1, pod2: 1 }, 'w_band_pod2', null],
    ['E2', { band: 1, pod2: 1, w_band_pod2: 1 }, null, null],
    ['E3', { band: 1, pod2: 1, band_w: 1 }, 'pod2_w', null],
    ['E4', { band: 1, pod2: 1, pod2_w: 1 }, 'band_w', null],
    ['E5', { band: 1, pod2: 1, band_w: 1, pod2_w: 1 }, null, null],
    ['E6', { band_lw: 1, pod2: 1 }, 'pod2_w', null],
    ['E7', { band_lw: 1, pod2: 1, pod2_w: 1 }, null, null],
    ['E8', { band: 1, pod2_lw: 1 }, 'band_w', null],
    ['E9', { band: 1, band_w: 1, pod2_lw: 1 }, null, null],
    ['E10', { band_lw: 1, pod2_lw: 1 }, null, null],
    ['F1', { band: 2 }, 'w_2band', 'pod2'],
    ['F2', { band: 2, w_2band: 1 }, null, 'pod2'],
    ['F3', { band: 2, band_w: 1 }, 'band_w', 'pod2'],
    ['F4', { band: 2, band_w: 2 }, null, 'pod2'],
    ['F5', { band: 1, band_lw: 1 }, 'band_w', 'pod2'],
    ['F6', { band: 1, band_lw: 1, band_w: 1 }, null, 'pod2'],
    ['F7', { band_lw: 2 }, null, 'pod2'],
    ['G1', { pod1: 2 }, 'w_2pod1', 'band'],
    ['G2', { pod1: 2, w_2pod1: 1 }, null, 'band'],
    ['G3', { pod1: 2, pod1_w: 1 }, 'pod1_w', 'band'],
    ['G4', { pod1: 2, pod1_w: 2 }, null, 'band'],
    ['G5', { pod1: 1, pod1_lw: 1 }, 'pod1_w', 'band'],
    ['G6', { pod1: 1, pod1_lw: 1, pod1_w: 1 }, null, 'band'],
    ['G7', { pod1_lw: 2 }, null, 'band']
  ];

  function signature(counts) {
    return Object.keys(counts)
      .filter(function (k) { return counts[k] > 0; })
      .sort()
      .map(function (k) { return k + ':' + counts[k]; })
      .join('|');
  }

  var BY_SIG = {};
  ROWS.forEach(function (r) { BY_SIG[signature(r[1])] = { row: r[0], warranty: r[2], product: r[3] }; });

  function sum(counts, roles) {
    return roles.reduce(function (n, r) { return n + (counts[r] || 0); }, 0);
  }
  function onlyRoles(counts, allowed) {
    return Object.keys(counts).every(function (k) { return !counts[k] || allowed.indexOf(k) > -1; });
  }

  function v2(lines) {
    var counts = {}, hasStrap = false;
    lines.forEach(function (l) {
      if (l.role === 'strap') { hasStrap = true; return; }
      var key = l.role || 'other';
      counts[key] = (counts[key] || 0) + l.quantity;
    });
    var bandPresent = sum(counts, BAND_FAMILY.concat(['bundle'])) > 0;
    var hit = BY_SIG[signature(counts)];

    if (!hit) {
      var devicesOk = onlyRoles(counts, POD2_FAMILY.concat(WARRANTY_ROLES));
      if (devicesOk && sum(counts, POD2_FAMILY) === 2) hit = { row: 'H1', warranty: null, product: 'band' };
      else if (onlyRoles(counts, POD1_FAMILY.concat(POD2_FAMILY, WARRANTY_ROLES)) &&
               sum(counts, POD1_FAMILY) === 1 && sum(counts, POD2_FAMILY) === 1) {
        hit = { row: 'H2', warranty: null, product: 'band' };
      }
    }
    if (!hit) hit = { row: Object.keys(counts).length ? 'Z' : null, warranty: null, product: null };

    return {
      row: hit.row,
      strap: !!hit.row && bandPresent && !hasStrap,
      warranty: hit.warranty,
      product: hit.product
    };
  }

  function v3(lines) {
    var counts = {};
    lines.forEach(function (l) {
      var key = l.role || 'other';
      counts[key] = (counts[key] || 0) + l.quantity;
    });
    var sig = signature(counts);
    if (sig === 'band:1') return { row: 'A1', swap: 'band', offer: 'pod' };
    if (sig === 'pod1:1') return { row: 'B1', swap: 'pod1', offer: 'band' };
    return { row: null };
  }

  return { v2: v2, v3: v3, ROWS: ROWS };
})();
if (typeof module !== 'undefined' && module.exports) module.exports = HumeCartRules;

(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  var cfgEl = document.getElementById('hume-cart-config');
  var rootEl = document.getElementById('HumeCart');
  if (!cfgEl || !rootEl) return;
  var CFG0 = JSON.parse(cfgEl.textContent);

  function activate(v) {
    if (window.__humeCartLoaded || !/^v[123]$/.test(v || '')) return;
    window.__humeCartLoaded = true;
    loadCss(function () { rootEl.hidden = false; boot(v); });
  }
  function loadCss(done) {
    if (!CFG0.cssUrl || document.querySelector('link[data-hc-css]')) return done();
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CFG0.cssUrl; l.setAttribute('data-hc-css', '');
    l.onload = l.onerror = function () { done(); };
    document.head.appendChild(l);
  }
  if (CFG0.variant === 'ab') {
    window.HumeCartActivate = activate;
    document.addEventListener('hume:cart:activate', function (e) { activate(e.detail && e.detail.variant); });
    if (window.__humeCartVariant) activate(window.__humeCartVariant);
  } else {
    activate(CFG0.variant);
  }

  function boot(VARIANT) {
  var root = rootEl;
  var CFG = CFG0;
  var ROOT_URL = /\/$/.test(CFG.root) ? CFG.root : CFG.root + '/';
  var RES_KEY = 'hume_cart_reserved_until';
  var TIMER_MS = (Number(CFG.timerMinutes) || 10) * 60 * 1000;

  CFG.reviews = CFG.reviews || {};
  if (!CFG.reviews.snippets) {
    CFG.reviews.snippets = String(CFG.reviews.snippetsRaw || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
  }
  if (!CFG.swatchMap) {
    CFG.swatchMap = {};
    String(CFG.swatchMapRaw || '').split(/\r?\n/).forEach(function (row) { 
      var i = row.indexOf(':');
      if (i > 0) CFG.swatchMap[row.slice(0, i).trim().toLowerCase()] = row.slice(i + 1).trim();
    });
  }

  var DEFAULT_COPY = {
    title: 'Your cart',
    timerOne: 'Your [product] is reserved for [time]',
    timerMany: 'Your order is reserved for [time]',
    expiredShort: 'Reservation expired',
    expired: 'Your reservation has expired.',
    expiredBody: 'Refresh to confirm stock availability.',
    refresh: 'Refresh',
    empty: 'Your cart is empty',
    total: 'Total',
    youSave: 'You save [amount]',
    saveBadge: 'SAVE [amount]',
    discountOff: '−[amount]',
    pctOff: '[pct]% OFF',
    installments: 'or 4 interest-free payments of [amount] with Shop Pay',
    checkout: 'Checkout',
    whatsIncluded: "What's included",
    lwIncluded: 'Includes 10-Year Extended Warranty',
    covers: 'Covers [device]',
    preorder: 'Pre Order',
    readyToShip: 'Ready to ship',
    soldOut: 'Out of stock',
    oosLine: 'This item is out of stock. Remove it to check out.',
    remove: 'Remove',
    error: 'Something went wrong. Please try again.',
    upsellHeading: 'Add to your order',
    crossHeading: 'Upgrade your order',
    crossTitle: 'Upgrade to the full Hume HealthOS',
    crossSaveMore: 'SAVE [amount] MORE',
    crossReplaces: 'Replaces [product] in your cart',
    crossAddPod: 'Add Hume Pod for [price]',
    crossAddBand: 'Add Band 2.0 for [price]',
    crossBodyFromBand: 'Band 2.0 shows why your days feel the way they do. Hume Pod shows what is changing in your body.',
    crossBodyFromPod: 'Hume Pod shows what is changing in your body. Band 2.0 shows why, from your sleep, HRV and strain.'
  };
  var COPY = {};
  Object.keys(DEFAULT_COPY).forEach(function (k) { COPY[k] = DEFAULT_COPY[k]; });
  Object.keys(CFG.copy || {}).forEach(function (k) { if (CFG.copy[k]) COPY[k] = CFG.copy[k]; });

  var CARDS = {
    strap:       { title: 'Add a second strap', body: 'Swap straps while one dries off, so your Band is never off for long.', button: 'Add strap' },
    pod2:        { title: 'Complete the picture with Pod 2.0', body: 'Band 2.0 follows your days. Hume Pod shows your body composition. Both sync to the same Hume app.', button: 'Add Pod 2.0' },
    band:        { title: "See what's driving your results", body: 'Hume Pod shows your body composition. Band 2.0 follows your days. Both sync to the same Hume app.', button: 'Add Band 2.0' },
    band_w:      { title: 'Extend your Band warranty to 10 years', body: "Add 10 years of extended warranty. If your Band has a fault, we'll repair or replace it.", button: 'Add warranty' },
    pod1_w:      { title: 'Extend your Pod warranty to 10 years', body: "Add 10 years of extended warranty. If your Pod has a fault, we'll repair or replace it.", button: 'Add warranty' },
    pod2_w:      { title: 'Extend your Pod 2.0 warranty to 10 years', body: "Add 10 years of extended warranty. If your Pod 2.0 has a fault, we'll repair or replace it.", button: 'Add warranty' },
    w_band_pod1: { title: '10 years of cover for both devices', body: "One extended warranty for your Band and Pod. If either has a fault, we'll repair or replace it.", button: 'Protect both' },
    w_band_pod2: { title: '10 years of cover for your full setup', body: "One extended warranty for your Band and Pod 2.0. If either has a fault, we'll repair or replace it.", button: 'Protect both' },
    w_2band:     { title: '10 years of cover for both Bands', body: "One extended warranty for both Bands. If either has a fault, we'll repair or replace it.", button: 'Protect both' },
    w_2pod1:     { title: '10 years of cover for both Pods', body: "One extended warranty for both Pods. If either has a fault, we'll repair or replace it.", button: 'Protect both' }
  };
  var COVERS = {
    band_w: 'Hume Band 2.0', pod1_w: 'Hume Pod 1', pod2_w: 'Hume Pod 2.0',
    w_band_pod1: 'Band 2.0 & Pod 1', w_band_pod2: 'Band 2.0 & Pod 2.0', w_2band: '2x Band 2.0', w_2pod1: '2x Pod 1'
  };
  var WARRANTY_OFFER = {
    band_w: 'band_warranty', pod1_w: 'pod1_warranty', pod2_w: 'pod2_warranty',
    w_band_pod1: 'band_pod1_warranty', w_band_pod2: 'band_pod2_warranty',
    w_2band: '2x_band_warranty', w_2pod1: '2x_pod1_warranty'
  };
  function warrantyOffer(role) {
    var v = String((CFG.warrantyOffers && CFG.warrantyOffers[role]) || WARRANTY_OFFER[role] || role).trim();
    var pre = CFG.warrantyOfferPrefix != null ? String(CFG.warrantyOfferPrefix).trim() : 'cd_';
    return pre && v.indexOf(pre) !== 0 ? pre + v : v;
  }
  var PRIMARY = ['band', 'band_lw', 'pod1', 'pod1_lw', 'pod2', 'pod2_lw', 'bundle'];
  var WARRANTY = ['band_w', 'pod1_w', 'pod2_w', 'w_band_pod1', 'w_band_pod2', 'w_2band', 'w_2pod1'];

  var els = {
    panel: root.querySelector('.hc__panel'),
    lines: root.querySelector('[data-hc-lines]'),
    offers: root.querySelector('[data-hc-offers]'),
    foot: root.querySelector('[data-hc-foot]'),
    timer: root.querySelector('[data-hc-timer]'),
    expired: root.querySelector('[data-hc-expired]'),
    reviews: root.querySelector('[data-hc-reviews]'),
    error: root.querySelector('[data-hc-error]'),
    count: root.querySelector('[data-hc-count]')
  };

  var byProductId = {}, byRole = {}, byVariantId = {}, rolePool = {};
  (CFG.products || []).forEach(function (p) {
    if (typeof p.whatsIncluded === 'string') {
      p.whatsIncluded = p.whatsIncluded.split(/\r?\n|<br\s*\/?>/i).map(function (x) { return x.replace(/<[^>]*>/g, '').trim(); }).filter(Boolean);
    } else if (!Array.isArray(p.whatsIncluded)) {
      p.whatsIncluded = [];
    }
    byProductId[p.id] = p;
    p.variants.forEach(function (v) { byVariantId[v.id] = { v: v, p: p }; });
    (rolePool[p.role] = rolePool[p.role] || []).push(p);
  });
  Object.keys(rolePool).forEach(function (role) {
    var list = rolePool[role];
    var inStock = function (x) { return x.variants.some(function (v) { return v.available; }); };
    byRole[role] = list.filter(function (x) { return x.upsell && inStock(x); })[0] ||
                   list.filter(inStock)[0] || list[0];
  });

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  // Always 2 decimals (e.g. Shop Pay installments), even if the store format has no decimals
  function money2(cents) {
    var saved = CFG.moneyFormat;
    CFG.moneyFormat = String(saved || '${{amount}}').replace(/amount_no_decimals_with_comma_separator/, 'amount_with_comma_separator').replace(/amount_no_decimals/, 'amount');
    try { return money(Math.round(cents)); } finally { CFG.moneyFormat = saved; }
  }
  function shortMoney(cents) { return money(cents).replace(/[.,]00(?=\D*$)/, ''); }
  function fill(tpl, key, val) {
    return String(tpl || '').replace(new RegExp('\\{' + key + '\\}|\\[' + key + '\\]', 'g'), val);
  }
  function firstAvailable(p) {
    if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }
  function compareOf(v) { return v && v.compare > v.price ? v.compare : 0; }

  var compareCache = {}, compareFetched = {};
  function unitCompare(item) {
    var m = byVariantId[item.variant_id];
    if (m && m.v.compare) return m.v.compare;
    return compareCache[item.variant_id] || 0;
  }
  function linePricing(item) {
    var cmp = unitCompare(item);
    var unitWas = Math.max(cmp, item.original_price || 0);
    var was = unitWas * item.quantity;
    var now = item.final_line_price;
    var discounts = (item.line_level_discount_allocations || []).map(function (a) {
      var app = a.discount_application || {};
      return { title: app.title || app.key || '', amount: a.amount };
    }).filter(function (d) { return d.amount > 0; });
    if (!discounts.length && item.discounts) {
      discounts = item.discounts.map(function (d) { return { title: d.title, amount: d.amount }; }).filter(function (d) { return d.amount > 0; });
    }
    return { was: was > now ? was : 0, now: now, save: was > now ? was - now : 0, discounts: discounts };
  }
  function ensureCompare(cart) {
    var todo = {};
    cart.items.forEach(function (i) {
      var m = byVariantId[i.variant_id];
      if ((!m || !m.v.compare) && !(i.variant_id in compareCache) && i.handle && !compareFetched[i.handle]) todo[i.handle] = true;
    });
    var handles = Object.keys(todo);
    if (!handles.length) return Promise.resolve(false);
    return Promise.all(handles.map(function (h) {
      compareFetched[h] = true;
      return nativeFetch(ROOT_URL + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          (prod && prod.variants || []).forEach(function (v) {
            compareCache[v.id] = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
          });
        }).catch(function () {});
    })).then(function () { return true; });
  }
  function roleOf(item) { var p = byProductId[item.product_id]; return p ? p.role : null; }
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, hume_cart_variant: VARIANT }, data || {}));
  }

  function svg(w, body, sw) {
    return '<svg viewBox="0 0 24 24" width="' + w + '" height="' + w + '" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + body + '</svg>';
  }
  function hourglassIcon(size) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M 14.36 10.879 C 17.431 10.879 19.921 13.369 19.921 16.44 C 19.921 19.51 17.431 22 14.36 22 C 11.289 22 8.8 19.51 8.8 16.44 C 8.8 13.369 11.289 10.879 14.36 10.879 Z M 13.434 17.366 L 17.14 17.366 L 17.14 15.513 L 15.286 15.513 L 15.286 13.659 L 13.434 13.659 L 13.434 17.366 Z" fill="currentColor" fill-rule="nonzero" transform="matrix(1 0 0 1 3.740 1.625)"></path>' +
      '<path d="M 16.632 2.079 L 14.554 2.079 L 14.554 4.158 C 14.554 5.141 14.26 6.011 13.805 6.785 C 12.521 6.858 11.305 7.181 10.204 7.706 C 10.544 7.423 10.86 7.139 11.143 6.847 C 12.023 5.937 12.474 5.078 12.474 4.158 L 12.474 2.079 L 4.158 2.079 L 4.158 4.158 C 4.158 5.078 4.609 5.937 5.49 6.847 C 6.209 7.591 7.138 8.288 8.163 9.016 C 6.462 10.438 5.259 12.434 4.847 14.706 C 4.391 15.345 4.158 15.973 4.158 16.633 L 4.158 18.712 L 4.961 18.712 C 5.136 19.441 5.394 20.137 5.725 20.791 L 0 20.791 L 0 18.712 L 2.079 18.712 L 2.079 16.633 C 2.079 14.954 2.927 13.603 3.996 12.499 C 4.726 11.744 5.616 11.048 6.517 10.396 C 5.616 9.743 4.726 9.048 3.996 8.292 C 2.927 7.188 2.079 5.837 2.079 4.158 L 2.079 2.079 L 0 2.079 L 0 0 L 16.632 0 L 16.632 2.079 Z" fill="currentColor" fill-rule="evenodd" transform="matrix(1 0 0 1 3.740 1.625)"></path>' +
      '</svg>';
  }
  var HG = '<path d="M6 2h12M6 22h12M7 2v4a5 5 0 0 0 10 0V2M7 22v-4a5 5 0 0 1 10 0v4"/>';
  var SH = '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/>';
  var ICON = {
    hourglass: hourglassIcon(14),
    hourglassLg: hourglassIcon(18),
    refresh: svg(14, '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>', 2),
    swap: svg(11, '<path d="M4 7h14l-3-3M20 17H6l3 3"/>', 2),
    trash: svg(14, '<path d="M10 11v6"/><path d="M14 11v6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>', 2),
    lock: svg(15, '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>', 2),
    shield: svg(12, SH, 2),
    shieldLg: svg(18, SH, 1.8),
    truck: svg(12, '<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>', 2),
    returns: svg(12, '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>', 2),
    tag: svg(11, '<path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.5"/>', 2),
    check: svg(11, '<path d="M5 12l5 5L20 7"/>', 2.4),
    left: svg(13, '<path d="M19 12H5M11 6l-6 6 6 6"/>', 2),
    right: svg(13, '<path d="M5 12h14M13 6l6 6-6 6"/>', 2)
  };

  var INTERNAL = 'X-Hume-Cart';
  var nativeFetch = window.fetch.bind(window);
  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    opts.headers[INTERNAL] = '1';
    if (body) {
      opts.method = 'POST';
      if (body instanceof FormData) { opts.body = body; }
      else { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    }
    return nativeFetch(ROOT_URL + path, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || COPY.error);
        return j;
      });
    });
  }
  var state = { cart: null, busy: false };

  function getCart() { return api('cart.js').then(function (c) { state.cart = c; return c; }); }
  function addItems(items) { return api('cart/add.js', { items: items }); }
  function changeLine(key, qty) { return api('cart/change.js', { id: key, quantity: qty }); }
  function applyCode(code) {
    return getCart().then(function (c) {
      var codes = (c.discount_codes || []).map(function (d) { return d.code; });
      if (codes.indexOf(code) > -1) return c;
      codes.push(code);
      return api('cart/update.js', { discount: codes.join(',') });
    });
  }

  function orphanWarrantyUpdates(cart) {
    var n = {};
    cart.items.forEach(function (i) { var r = roleOf(i); if (r) n[r] = (n[r] || 0) + i.quantity; });
    var bands = (n.band || 0) + (n.bundle || 0);
    var pod1s = (n.pod1 || 0) + (n.bundle || 0);
    var pod2s = n.pod2 || 0;
    var cap = {
      band_w: bands, pod1_w: pod1s, pod2_w: pod2s,
      w_band_pod1: Math.min(bands, pod1s), w_band_pod2: Math.min(bands, pod2s),
      w_2band: Math.floor(bands / 2), w_2pod1: Math.floor(pod1s / 2)
    };
    var used = {}, updates = {}, any = false;
    cart.items.forEach(function (i) {
      var r = roleOf(i);
      if (WARRANTY.indexOf(r) < 0) return;
      var room = Math.max(0, cap[r] - (used[r] || 0));
      var keep = Math.min(i.quantity, room);
      used[r] = (used[r] || 0) + keep;
      if (keep !== i.quantity) { updates[i.key] = keep; any = true; }
    });
    return any ? updates : null;
  }

  function run(promise) {
    state.busy = true; root.classList.add('is-busy'); showError('');
    return promise
      .then(getCart)
      .then(function (c) {
        var fix = orphanWarrantyUpdates(c);
        return fix ? api('cart/update.js', { updates: fix }).then(getCart) : c;
      })
      .then(function (c) { render(c); return c; })
      .catch(function (e) { showError(e.message); return getCart().then(render); })
      .then(function () { state.busy = false; root.classList.remove('is-busy'); });
  }
  function refreshStock() {
    var handles = {};
    (state.cart ? state.cart.items : []).forEach(function (i) { if (i.handle) handles[i.handle] = true; });
    return Promise.all(Object.keys(handles).map(function (h) {
      return nativeFetch(ROOT_URL + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod) return;
          prod.variants.forEach(function (pv) {
            var m = byVariantId[pv.id];
            if (m) m.v.available = !!pv.available;
          });
        })
        .catch(function () {});
    }));
  }

  function showError(msg) {
    els.error.textContent = msg || '';
    els.error.hidden = !msg;
    els.error.style.display = msg ? '' : 'none';
  }

  var timerTick = null;
  var memReservation = 0;
  function getReservation() {
    try { var v = localStorage.getItem(RES_KEY); return v === null ? memReservation : (Number(v) || 0); }
    catch (e) { return memReservation; }
  }
  function setReservation(ts) {
    memReservation = ts || 0;
    try { ts ? localStorage.setItem(RES_KEY, String(ts)) : localStorage.removeItem(RES_KEY); } catch (e) {}
  }
  function startReservation() { setReservation(Date.now() + TIMER_MS); }

  function timerLabel(t) {
    var items = state.cart.items;
    var one = items.length === 1 && items[0].quantity === 1;
    var tpl = one ? fill(COPY.timerOne, 'product', esc(items[0].product_title)) : esc(COPY.timerMany);
    return fill(tpl, 'time', '<strong class="hc__time">' + t + '</strong>');
  }

  function renderTimer() {
    clearInterval(timerTick);
    if (!state.cart || !state.cart.item_count) {
      els.timer.hidden = true; els.expired.hidden = true; root.classList.remove('is-expired'); setReservation(0); return;
    }
    if (!getReservation()) startReservation();
    els.timer.hidden = false;
    function tick() {
      var left = getReservation() - Date.now();
      if (left <= 0) {
        clearInterval(timerTick);
        root.classList.add('is-expired');
        els.timer.innerHTML = ICON.hourglass + '<span>' + esc(COPY.expiredShort) + '</span>';
        els.expired.hidden = false;
        els.expired.innerHTML =
          '<div class="hc__exp__outer"><div class="hc__exp-icon">' + ICON.hourglassLg + '</div>' +
          '<div class="hc__exp___ct"><p class="hc__exp-title">' + esc(COPY.expired) + '</p>' +
          '<p class="hc__exp-body">' + esc(COPY.expiredBody) + '</p>' +
          '</div></div><div class="hc__exp___btn"><button type="button" class="hc__pill" data-hc-refresh>' + ICON.refresh + '<span>' + esc(COPY.refresh) + '</span></button></div>';
        if (!renderTimer.tracked) { track('hume_cart_reservation_expired'); renderTimer.tracked = true; }
        return;
      }
      root.classList.remove('is-expired');
      els.expired.hidden = true;
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      els.timer.innerHTML = ICON.hourglass + '<span>' + timerLabel((m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s) + '</span>';
    }
    tick();
    timerTick = setInterval(tick, 1000);
  }

  var STAR = '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="0" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>';
  function renderReviews() {
    var r = CFG.reviews || {};
    var snippets = (r.snippets || []).filter(Boolean);
    if (!r.rating && !snippets.length) { els.reviews.hidden = true; return; }
    els.reviews.hidden = false;
    var items = snippets.map(function (s) { return '<span class="hc__rev-snip">“' + esc(s) + '”</span>'; }).join('');
    els.reviews.innerHTML =
      (r.rating ? '<span class="hc__rev-score"><strong>' + esc(r.rating) + '</strong><span class="hc__stars" aria-hidden="true">' + STAR + STAR + STAR + STAR + STAR + '</span></span>' : '') +
      (items ? '<span class="hc__rev-track__empty"></span><div class="hc__rev-track"><div class="hc__rev-inner">' + items + items + '</div></div>' : '');
  }

  function mapColour(name) { return (CFG.swatchMap && CFG.swatchMap[String(name || '').toLowerCase()]) || ''; }
  function optionOf(p, v) {
    var name = (p.colourIndex > -1 ? v.options[p.colourIndex] : '') || p.swatchName || '';
    var color = (p.colourIndex > -1 && p.swatches && p.swatches[name]) || p.swatchColor || mapColour(name) || '#d1d5db';
    return { id: v.id, p: p, v: v, name: name, color: color };
  }
  function colourGroup(p) {
    return (CFG.products || []).filter(function (x) { return x.role === p.role && x.swatchName; });
  }
  function colourOptions(p, v) {
    if (!p || !v) return [];
    var group = colourGroup(p);
    if (group.length > 1 && p.swatchName) {
      return group.map(function (x) { return optionOf(x, x.id === p.id ? v : (firstAvailable(x) || x.variants[0])); });
    }
    if (p.colourIndex < 0 || p.variants.length < 2) return [];
    var others = v.options.filter(function (_, i) { return i !== p.colourIndex; }).join('/');
    return p.variants.filter(function (x) {
      return x.options.filter(function (_, i) { return i !== p.colourIndex; }).join('/') === others;
    }).map(function (x) { return optionOf(p, x); });
  }
  function preorderText(v) { return COPY.preorder + (v.preorderNote ? ' - ' + v.preorderNote : ''); }
  function stockLabel(v) { return !v.available ? COPY.soldOut : (v.preorder ? preorderText(v) : COPY.readyToShip); }
  function swatchesHTML(p, current, attrs) {
    var list = colourOptions(p, current);
    if (list.length < 2) return '';
    return '<div class="hc__swatches" role="radiogroup" aria-label="Colour">' + list.map(function (o) {
      var on = o.id === current.id;
      return '<button type="button" class="hc__swatch' + (on ? ' is-active' : '') + '"' +
        ' role="radio" aria-checked="' + on + '" aria-label="' + esc(o.name + ' — ' + stockLabel(o.v)) + '" title="' + esc(o.name) + '"' +
        (o.v.available ? '' : ' disabled') + ' ' + attrs(o.v) + '>' +
        '<span class="hc__swatch-color" style="background-color:' + esc(o.color) + '"></span></button>';
    }).join('') + '</div>' + swatchStatus(optionOf(p, current));
  }
  function swatchStatus(o) {
    return '<div class="hc__sw-status"><span class="hc__dot' + (o.v.preorder ? ' is-pre' : '') + '"></span><strong>' +
      esc(o.name) + '</strong>&nbsp;· ' + esc(stockLabel(o.v)) + '</div>';
  }
  function displayName(p, item) { return (p && p.cartTitle) || item.product_title; }

  function stepper(item, compact, oos) {
    var minus = item.quantity <= 1 ?
      '<button type="button" data-hc-qty="' + esc(item.key) + '" data-q="0" aria-label="' + esc(COPY.remove) + '">' + ICON.trash + '</button>' :
      '<button type="button" data-hc-qty="' + esc(item.key) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>';
    return '<div class="hc__qty' + (compact ? ' hc__qty--sm' : '') + '">' + minus + '<span>' + item.quantity + '</span>' +
      '<button type="button" data-hc-qty="' + esc(item.key) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase"' + (oos ? ' disabled' : '') + '>+</button></div>';
  }
  function priceCol(item, pr) {
    return '<div class="hc__l-price"><div class="hc__now">' + money(pr.now) + '</div>' +
      (pr.was ? '<s class="hc__was">' + money(pr.was) + '</s>' : '') + '</div>';
  }
  function includedList(list) {
    var comps = [], rest = [];
    list.forEach(function (w) {
      var parts = String(w).split('|').map(function (s) { return s.trim(); });
      if (parts.length >= 3) comps.push(parts); else rest.push(w);
    });
    return '<div class="hc__incl" hidden>' +
      (comps.length ? '<ul class="hc__comps">' + comps.map(function (c) {
        return '<li>' + ICON.check + '<strong>' + esc(c[0]) + '</strong><span class="hc__comp-p"><s>' + esc(c[1]) + '</s> ' + esc(c[2]) + '</span></li>';
      }).join('') + '</ul>' : '') +
      (rest.length ? '<ul class="hc__checks">' + rest.map(function (w) { return '<li>' + ICON.check + esc(w) + '</li>'; }).join('') + '</ul>' : '') +
      '</div>';
  }

  function lineHTML(item, index) {
    var meta = byVariantId[item.variant_id];
    var p = meta && meta.p, v = meta && meta.v;
    var role = p ? p.role : null;
    var oos = v ? !v.available : false;
    var pr = linePricing(item);
    var save = pr.save;
    var disc = pr.discounts.length ? '<div class="hc__discs">' + pr.discounts.map(function (d) {
      return '<span class="hc__disc">' + ICON.tag + '<span>' + esc(d.title) + '</span><span class="hc__disc-amt">' + esc(fill(COPY.discountOff, 'amount', money(d.amount))) + '</span></span>';
    }).join('') + '</div>' : '';
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : (p && p.image);
    var thumb = '<div class="hc__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</div>';
    var chip = save > 0 ? '<span class="hc__save">' + esc(fill(COPY.saveBadge, 'amount', shortMoney(save))) + '</span>' : '';
    var oosMsg = oos ? '<p class="hc__oos">' + esc(COPY.oosLine) + '</p>' : '';
    var open = '<li class="hc__line hc__line--';

    if (WARRANTY.indexOf(role) > -1) {
      return open + 'compact hc__line--warranty' + (oos ? ' is-oos' : '') + '" data-key="' + esc(item.key) + '">' +
        '<div class="hc__img hc__img--icon">' + ICON.shieldLg + '</div>' +
        '<div class="hc__info"><div class="hc__l-top"><div class="hc__l-main"><div class="hc__name">' + esc(displayName(p, item)) + '</div>' +
        '<div class="hc__sub">' + esc(fill(COPY.covers, 'device', COVERS[role] || '')) + '</div></div>' + priceCol(item, pr) + '</div>' + disc +
        '<div class="hc__l-bottom">' + stepper(item, true, oos) + chip + '</div>' + oosMsg + '</div></li>';
    }

    if (PRIMARY.indexOf(role) < 0) {
      var sub = '';
      var cname = v && p ? optionOf(p, v).name : '';
      if (cname) {
        sub = '<span class="hc__colour-name">' + esc(cname) + (v.preorder ? ' · ' + esc(preorderText(v)) : '') + '</span>';
      } else if (item.variant_title && !item.product_has_only_default_variant) {
        sub = esc(item.variant_title);
      }
      return open + 'compact' + (oos ? ' is-oos' : '') + '" data-key="' + esc(item.key) + '">' + thumb +
        '<div class="hc__info"><div class="hc__l-top"><div class="hc__l-main"><a class="hc__name" href="' + esc(item.url) + '">' + esc(displayName(p, item)) + '</a>' +
        (sub ? '<div class="hc__sub">' + sub + '</div>' : '') + '</div>' + priceCol(item, pr) + '</div>' + disc +
        '<div class="hc__l-bottom">' + stepper(item, true, oos) + chip + '</div>' + oosMsg + '</div></li>';
    }

    var included = p && p.whatsIncluded && p.whatsIncluded.length ? p.whatsIncluded : null;
    var lw = /_lw$/.test(role) ? '<div class="hc__lw">' + ICON.shield + '<span>' + esc(COPY.lwIncluded) + '</span></div>' : '';
    var pre = v && v.preorder ? '<div class="hc__sub">' + esc(preorderText(v)) + '</div>' : '';
    var colour = v ? swatchesHTML(p, v, function (x) { return 'data-hc-colour="' + x.id + '" data-hc-line="' + index + '"'; }) : '';
    return open + 'primary' + (oos ? ' is-oos' : '') + '" data-key="' + esc(item.key) + '">' + thumb +
      '<div class="hc__info">' +
        '<div class="hc__l-top"><div class="hc__l-main"><a class="hc__name" href="' + esc(item.url) + '">' + esc(displayName(p, item)) + '</a>' +
          lw + pre +
          (included ? '<button type="button" class="hc__incl-toggle" aria-expanded="false" data-hc-toggle>' + esc(COPY.whatsIncluded) + ' <span class="hc__plus" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M 7.714 7.714 L 7.714 0 L 10.286 0 L 10.286 7.714 L 18 7.714 L 18 10.286 L 10.286 10.286 L 10.286 18 L 7.714 18 L 7.714 10.286 L 0 10.286 L 0 7.714 L 7.714 7.714 Z" fill="currentColor" fill-rule="evenodd" transform="matrix(1 0 0 1 3 3)"></path></svg></span></button>' : '') +
        '</div>' + priceCol(item, pr) + '</div>' +
        (included ? includedList(included) : '') +  
        disc +                                     
        colour +
        '<div class="hc__l-bottom">' + stepper(item, false, oos) + chip + '</div>' + oosMsg +
      '</div></li>';
  }

  function pctOf(o) { var n = parseFloat(String(o && o.pct != null ? o.pct : '').replace(',', '.').replace(/[^0-9.]/g, '')); return n > 0 && n < 100 ? n : 0; }
  function offerFor(role) { var o = (CFG.offers || {})[role]; var n = pctOf(o); return n ? { pct: n, code: o.code } : null; }
  function priceHTML(v, role) {
    var c = compareOf(v);
    var offer = role ? offerFor(role) : null;
    if (offer) {
      var was = Math.max(c, v.price);
      var now = Math.round(was * (100 - Number(offer.pct)) / 100); 
      if (Math.abs(now - v.price) < 50) now = v.price;
      var shownPct = Math.round(offer.pct);
      return '<span class="hc__c-price">' + money(now) + '</span> <s class="hc__was">' + money(was) + '</s>' +
        ' <span class="hc__pct" style="display:inline-block;font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;font-weight:700;font-size:11px;letter-spacing:.03em;color:#0B2A5B;background:#8DBDFF;padding:2px 6px;border-radius:3px">' + esc(fill(COPY.pctOff, 'pct', String(shownPct))   /* badge: 49.28 → 49; price uses exact % */) + '</span>';
    }
    return '<span class="hc__c-price">' + money(v.price) + '</span>' + (c ? ' <s class="hc__was">' + money(c) + '</s>' : '');
  }
  function strapDefault() {
    var main = byRole.strap, v = upsellVariant(main);
    if (v) return { p: main, v: v };
    var group = (CFG.products || []).filter(function (x) { return x.role === 'strap'; });
    for (var i = 0; i < group.length; i++) { var fv = firstAvailable(group[i]); if (fv) return { p: group[i], v: fv }; }
    return null;
  }

  function upsellVariant(p) {
    if (!p) return null;
    var want = p.upsellVariantId && p.variants.filter(function (x) { return x.id === p.upsellVariantId && x.available; })[0];
    if (want) return want;
    if (p.upsellOption) {
      var o = String(p.upsellOption).toLowerCase();
      var byOpt = p.variants.filter(function (x) {
        return x.available && x.options.some(function (val) { return String(val).toLowerCase() === o; });
      })[0];
      if (byOpt) return byOpt;
    }
    return firstAvailable(p);
  }
  function upsellCard(kind, role) {
    var copy = CARDS[role];
    var sel = kind === 'strap' ? strapDefault() : (function () { var p = byRole[role]; var v = upsellVariant(p); return v ? { p: p, v: v } : null; })();
    if (!sel || !copy) return ''; 
    var p = sel.p, v = sel.v;
    var media = kind === 'warranty' ?
      '<div class="hc__c-thumb hc__c-thumb--icon">' + ICON.shieldLg + '</div>' :
      '<div class="hc__c-thumb">' + ((v.image || p.image) ? '<img src="' + esc(v.image || p.image) + '" alt="" loading="lazy">' : '') + '</div>';
    var sw = kind === 'strap' ? swatchesHTML(p, v, function (x) { return 'data-hc-pick="' + x.id + '"'; }) : '';
    return '<div class="hc__card hc__card--' + kind + '" data-role="' + esc(role) + '">' +
      '<div class="hc__c-head">' + media +
        '<div><div class="hc__c-title">' + esc(copy.title) + '</div><div class="hc__c-prices">' + priceHTML(v, role) + '</div></div>' +
      '</div>' +
      '<p class="hc__c-body">' + esc(copy.body) + '</p>' + sw +
      '<button type="button" class="hc__outline" data-hc-upsell="' + v.id + '" data-kind="' + kind + '" data-role="' + esc(role) + '">' + esc(copy.button) + '</button>' +
      '</div>';
  }

  function renderOffers(cart, lines) {
    els.offers.className = 'hc__offers';
    if (VARIANT === 'v2') {
      var r = HumeCartRules.v2(lines);
      root.dataset.hcRow = r.row || '';
      var list = [];
      if (r.strap) list.push(upsellCard('strap', 'strap'));
      if (r.warranty) list.push(upsellCard('warranty', r.warranty));
      if (r.product) list.push(upsellCard('product', r.product));
      list = list.filter(Boolean);
      if (!list.length) { els.offers.innerHTML = ''; els.offers.hidden = true; return; }  
      els.offers.hidden = false;
      els.offers.classList.toggle('is-single', list.length < 2);                            
      els.offers.innerHTML =
        '<div class="hc__offers-head"><h3 class="hc__offers-title">' + esc(COPY.upsellHeading) + '</h3>' +
        (list.length > 1 ? '<div class="hc__arrows"><button type="button" data-hc-scroll="-1" aria-label="Previous">' + ICON.left + '</button>' +
          '<button type="button" data-hc-scroll="1" aria-label="Next">' + ICON.right + '</button></div>' : '') +
        '</div><div class="hc__cards" data-hc-track>' + list.join('') + '</div>';
      return;
    }
    if (VARIANT === 'v3') {
      var x = HumeCartRules.v3(lines);
      root.dataset.hcRow = x.row || '';
      var bundle = byRole.bundle, bv = firstAvailable(bundle);
      if (!x.row || !bv) { els.offers.innerHTML = ''; els.offers.hidden = true; return; }
      var line = cart.items[0];

      var otherRole = x.offer === 'pod' ? 'pod1' : 'band';
      var other = upsellVariant(byRole[otherRole]);

      var otherPct = parseFloat(String(((CFG.v3Device || {})[otherRole]) || '').replace(',', '.')) || 0;
      if (other && otherPct > 0 && otherPct < 100) {
        other = { price: Math.round(Math.max(compareOf(other), other.price) * (100 - otherPct) / 100) };
      }
      root.dataset.hcV3Other = other ? (byRole[otherRole].title + ' | ' + other.price) : '';

      var bOffer = offerFor('bundle');
      var bWas = Math.max(compareOf(bv), bv.price);
      var bNow = bv.price;
      if (bOffer) {
        bNow = Math.round(bWas * (100 - Number(bOffer.pct)) / 100);
        if (Math.abs(bNow - bv.price) < 50) bNow = bv.price;
      }
      var bPrices = '<span class="hc__c-price">' + money(bNow) + '</span>' + (bWas > bNow ? ' <s class="hc__was">' + money(bWas) + '</s>' : '');
      var diff = Math.max(0, bNow - line.final_line_price);
      var more = other ? (line.final_line_price + other.price) - bNow : 0;
      var heroImg = CFG.v3Image || bundle.image;
      els.offers.hidden = false;
      els.offers.classList.add('is-single');
      els.offers.innerHTML =
        '<div class="hc__offers-head"><h3 class="hc__offers-title">' + esc(COPY.crossHeading) + '</h3></div>' +
        '<div class="hc__card hc__card--cross">' +
          '<div class="hc__cross-head">' +
            '<div class="hc__c-title">' + esc(COPY.crossTitle) + '</div>' +
            '<div class="hc__c-prices">' + bPrices +
              (more > 0 ? ' <span class="hc__save">' + esc(fill(COPY.crossSaveMore, 'amount', shortMoney(more))) + '</span>' : '') + '</div>' +
          '</div>' +
          '<div class="hc__cross-img">' + (heroImg ? '<img src="' + esc(heroImg) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<p class="hc__c-body">' + esc(x.offer === 'pod' ? COPY.crossBodyFromBand : COPY.crossBodyFromPod) + '</p>' +
          '<div class="hc__replaces">' + ICON.swap + '<span>' + esc(fill(COPY.crossReplaces, 'product', line.product_title)) + '</span></div>' +
          '<button type="button" class="hc__outline" data-hc-cross="' + esc(line.key) + '" data-device="' + line.variant_id + '" data-bundle="' + bv.id + '">' +
            esc(fill(x.offer === 'pod' ? COPY.crossAddPod : COPY.crossAddBand, 'price', shortMoney(diff))) + '</button>' +
        '</div>';
      return;
    }
    els.offers.innerHTML = ''; els.offers.hidden = true; 
  }

  function renderFoot(cart) {
    var items = cart.items;
    var compareTotal = items.reduce(function (n, i) { var pr = linePricing(i); return n + (pr.was || pr.now); }, 0);
    var saved = compareTotal - cart.total_price;
    var orderDisc = (cart.cart_level_discount_applications || []).filter(function (d) { return d.total_allocated_amount > 0; });
    var blocked = items.some(function (i) { var m = byVariantId[i.variant_id]; return m && !m.v.available; });

    var inst = '';
    var I = CFG.installments || {};
    if (I.enabled && cart.total_price >= (I.min || 0)) {
      inst = '<div class="hc__inst">' + fill(esc(COPY.installments), 'amount', '<strong>' + money2(Math.ceil(cart.total_price / 4)) + '</strong>')
        .replace('Shop Pay', '<span class="hc__shoppay">Shop Pay</span>') + '</div>';
    }
    var trust = (CFG.trust || []).filter(Boolean);
    var trustIcons = [ICON.shield, ICON.truck, ICON.returns];

    els.foot.innerHTML =
      (orderDisc.length ? '<div class="hc__order-discs">' + orderDisc.map(function (d) {
        return '<div class="hc__order-disc"><span>' + ICON.tag + esc(d.title || d.key || '') + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
      }).join('') + '</div>' : '') +
      '<div class="hc__total"><span class="hc__total-label">' + esc(COPY.total) + '</span>' +
        '<span class="hc__total-right">' +
          (saved > 0 ? '<span class="hc__you-save">' + esc(fill(COPY.youSave, 'amount', money(saved))) + '</span><s class="hc__was">' + money(compareTotal) + '</s>' : '') +
          '<strong class="hc__total-now">' + money(cart.total_price) + '</strong></span></div>' +
      inst +
      '<a class="hc__btn hc__checkout' + (blocked ? ' is-disabled' : '') + '" href="' + ROOT_URL + 'checkout"' +
        (blocked ? ' aria-disabled="true" tabindex="-1"' : '') + ' data-hc-checkout>' + ICON.lock + '<span>' + esc(COPY.checkout) + '</span></a>' +
      (trust.length ? '<ul class="hc__trust">' + trust.map(function (t, i) { return '<li>' + (trustIcons[i] || '') + '<span>' + esc(t) + '</span></li>'; }).join('') + '</ul>' : '');
  }

  var COUNT_SELECTORS = [
    '[data-hc-count-badge]', '[data-cart-count]', '.cart-count', '.cart-count-bubble span:not(.visually-hidden)',
    '.js-cart-count', '.header__cart-count', '.site-header__cart-count span', 'cart-count', '#CartCount', '.cart-link__bubble-num'
  ];
  function syncHeaderCount(n) {
    var sel = COUNT_SELECTORS.concat(String(CFG.countSelector || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean));
    sel.forEach(function (q) {
      var nodes;
      try { nodes = document.querySelectorAll(q); } catch (e) { return; }
      nodes.forEach(function (el) {
        if (root.contains(el)) return;
        el.textContent = n;
        el.setAttribute('data-count', n);
        var bubble = el.closest('.cart-count-bubble, [data-cart-bubble]');
        if (bubble) bubble.hidden = n === 0;
      });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: n } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function render(cart) {
    state.cart = cart;
    var items = cart.items || [];
    els.count.textContent = '(' + (cart.item_count || 0) + ')';
    syncHeaderCount(cart.item_count);

    if (!items.length) {
      var E = CFG.emptyCtas || {};
      var link = function (path) { path = String(path || '').trim(); return /^https?:|^\//.test(path) ? path : ROOT_URL + path.replace(/^\/+/, ''); };
      var btn1 = E.label1 !== '' ? '<a class="hc__btn hc__empty-btn" href="' + esc(link(E.url1 || 'pages/hume-bandv2')) + '" data-hc-empty-cta="1">' + esc(E.label1 || 'Shop Hume Band 2.0') + '</a>' : '';
      var btn2 = E.label2 !== '' ? '<a class="hc__outline hc__empty-btn" href="' + esc(link(E.url2 || 'pages/hume-body-pod')) + '" data-hc-empty-cta="2">' + esc(E.label2 || 'Shop Hume Pod') + '</a>' : '';
      els.lines.innerHTML = '<li class="hc__empty"><p class="hc__empty-title">' + esc(COPY.empty) + '</p>' +
        '<div class="hc__empty-ctas">' + btn1 + btn2 + '</div></li>';
      els.offers.innerHTML = ''; els.offers.hidden = true;
      els.foot.innerHTML = '';
      els.reviews.hidden = true;          
      els.expired.hidden = true;
      showError('');
      root.dataset.hcRow = '';
      root.classList.add('is-empty');
      renderTimer();                      
      return;
    }
    if (root.classList.contains('is-empty')) renderReviews();   
    root.classList.remove('is-empty');

    var rank = function (i) { var r = roleOf(i); return PRIMARY.indexOf(r) > -1 ? 0 : (WARRANTY.indexOf(r) > -1 ? 2 : 1); };
    var ordered = items.map(function (it, idx) { return { it: it, idx: idx }; })
      .sort(function (a, b) { return rank(a.it) - rank(b.it) || a.idx - b.idx; });
    els.lines.innerHTML = ordered.map(function (o) { return lineHTML(o.it, o.idx); }).join('');
    renderOffers(cart, items.map(function (i) { return { role: roleOf(i), quantity: i.quantity }; }));
    renderFoot(cart);
    renderTimer();
    ensureCompare(cart).then(function (changed) { if (changed && state.cart === cart) render(cart); });
    document.dispatchEvent(new CustomEvent('hume:cart:updated', { detail: { cart: cart, variant: VARIANT } }));
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hc-lock');
    setTimeout(function () { els.panel.focus(); }, 50);
    track('hume_cart_open', { hume_cart_row: root.dataset.hcRow || '' });
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshAndOpen() { return getCart().then(function (c) { render(c); open(); }); }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-hc-close]')) { close(); return; }
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;

    if (t.hasAttribute('data-hc-toggle')) {
      var panel = t.closest('.hc__info').querySelector('.hc__incl');
      var openNow = t.getAttribute('aria-expanded') !== 'true';
      t.setAttribute('aria-expanded', String(openNow));
      if (panel) panel.hidden = !openNow;
      return;
    }
    if (t.hasAttribute('data-hc-scroll')) {
      var track_ = els.offers.querySelector('[data-hc-track]');
      if (track_) window.HumeCartGoToCard(track_, Number(t.dataset.hcScroll) > 0 ? 1 : -1);
      return;
    }
    if (t.hasAttribute('data-hc-pick')) {
      var cardEl = t.closest('.hc__card');
      var pickId = Number(t.getAttribute('data-hc-pick'));
      var m = byVariantId[pickId];
      if (!m) return;
      var cardRole = cardEl.getAttribute('data-role');
      cardEl.querySelectorAll('.hc__swatch').forEach(function (b) {
        var on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', String(on));
      });
      cardEl.querySelector('.hc__sw-status').outerHTML = swatchStatus(optionOf(m.p, m.v));
      cardEl.querySelector('.hc__c-prices').innerHTML = priceHTML(m.v, cardRole);
      var thumbEl = cardEl.querySelector('.hc__c-thumb');
      if (thumbEl && !thumbEl.classList.contains('hc__c-thumb--icon')) thumbEl.innerHTML = (m.v.image || m.p.image) ? '<img src="' + esc(m.v.image || m.p.image) + '" alt="" loading="lazy">' : '';
      cardEl.querySelector('[data-hc-upsell]').setAttribute('data-hc-upsell', String(pickId));
      track('hume_cart_swatch_pick', { variant_id: pickId, colour: optionOf(m.p, m.v).name });
      return;
    }

    if (state.busy) { e.preventDefault(); return; }

    if (t.hasAttribute('data-hc-refresh')) {
      startReservation(); renderTimer.tracked = false;
      run(refreshStock());
      track('hume_cart_reservation_refresh');
      return;
    }

    var expiredLock = root.classList.contains('is-expired');

    if (t.hasAttribute('data-hc-qty')) {
      if (expiredLock) return;
      run(changeLine(t.getAttribute('data-hc-qty'), Math.max(0, Number(t.dataset.q))));
      return;
    }

    if (t.hasAttribute('data-hc-colour')) {
      if (expiredLock) return;
      var item = state.cart.items[Number(t.dataset.hcLine)];
      var newId = Number(t.getAttribute('data-hc-colour'));
      if (!item || newId === item.variant_id) return;
      run(addItems([{ id: newId, quantity: item.quantity, properties: item.properties || {} }])
        .then(function () { return changeLine(item.key, 0); }));
      track('hume_cart_colour_change', { variant_id: newId });
      return;
    }

    if (t.hasAttribute('data-hc-upsell')) {
      var kind = t.dataset.kind;
      var offer = offerFor(t.dataset.role);
      var props = WARRANTY.indexOf(t.dataset.role) > -1 ?
        { _offer: warrantyOffer(t.dataset.role) } :
        { _hc_source: 'cart_' + VARIANT + '_' + kind, _hc_row: root.dataset.hcRow || '' };
      run(addItems([{ id: Number(t.getAttribute('data-hc-upsell')), quantity: 1, properties: props }])
        .then(function () { return offer && offer.code ? applyCode(offer.code) : null; }));
      track('hume_cart_upsell_add', { upsell_type: kind, upsell_role: t.dataset.role, hume_cart_row: root.dataset.hcRow || '' });
      return;
    }

    if (t.hasAttribute('data-hc-cross')) {
      var bundleId = Number(t.dataset.bundle);
      var deviceId = Number(t.dataset.device);
      run(addItems([{ id: bundleId, quantity: 1, properties: { _hc_source: 'cart_v3_cross', _hc_row: root.dataset.hcRow || '' } }])
        .then(getCart)
        .then(function (c) {
          var updates = {};
          c.items.forEach(function (i) { if (i.variant_id === deviceId) updates[i.key] = 0; });
          return Object.keys(updates).length ? api('cart/update.js', { updates: updates }) : null;
        }));
      track('hume_cart_crosssell_add', { hume_cart_row: root.dataset.hcRow || '' });
      return;
    }

    if (t.hasAttribute('data-hc-checkout')) {
      if (t.classList.contains('is-disabled')) { e.preventDefault(); return; }
      track('hume_cart_checkout');
    }
  });
  function cardStops(track) {
    var tr = track.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || parseFloat(getComputedStyle(track).paddingLeft) || 0;
    var max = track.scrollWidth - track.clientWidth;
    return [].map.call(track.querySelectorAll('.hc__card'), function (c) {
      return Math.max(0, Math.min(max, Math.round(c.getBoundingClientRect().left - tr.left + track.scrollLeft - pad)));
    }).filter(function (v, i, arr) { return arr.indexOf(v) === i; });
  }
  function nearestStop(stops, x) {
    var best = 0;
    stops.forEach(function (v, i) { if (Math.abs(v - x) < Math.abs(stops[best] - x)) best = i; });
    return best;
  }
  function goToCard(track, dir, fromLeft) {
    var stops = cardStops(track);
    if (!stops.length) return;
    var i = nearestStop(stops, fromLeft == null ? track.scrollLeft : fromLeft);
    var j = Math.max(0, Math.min(stops.length - 1, i + dir));
    track.scrollTo({ left: stops[j], behavior: 'smooth' });
  }
  window.HumeCartGoToCard = goToCard;   

  var drag = null;
  root.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('[data-hc-track]');
    if (!track || track.scrollWidth <= track.clientWidth + 1) return;
    drag = { track: track, x: e.clientX, left: track.scrollLeft, moved: false };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 6) return;                  
    if (!drag.moved) {
      drag.moved = true;
      drag.track.classList.add('is-dragging');
      drag.track.style.scrollSnapType = 'none';
      drag.track.style.scrollBehavior = 'auto';
      drag.track.style.userSelect = 'none';
      drag.track.style.cursor = 'grabbing';
    }
    e.preventDefault();
    drag.track.scrollLeft = drag.left - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!drag) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    var moved = d.track.scrollLeft - d.left;                       
    var dir = Math.abs(moved) > 40 ? (moved > 0 ? 1 : -1) : 0;
    goToCard(d.track, dir, d.left);
    setTimeout(function () {                                        
      d.track.classList.remove('is-dragging');
      d.track.style.scrollSnapType = d.track.style.scrollBehavior = d.track.style.userSelect = d.track.style.cursor = '';
    }, 450);
    var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
    root.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(function () { root.removeEventListener('click', stop, { capture: true }); }, 50);
  });
  root.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('[data-hc-track]')) e.preventDefault(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  renderReviews();

  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var PERMALINK_RE = /\/cart\/(\d+:\d+(,\d+:\d+)*)/;
  var recentAddUntil = 0;
  function markAdd() { recentAddUntil = Date.now() + 2500; startReservationIfEmpty(); }
  function startReservationIfEmpty() { if (!state.cart || !state.cart.item_count) startReservation(); }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-hc-ignore')) return;
    if (!CART_ADD_RE.test(form.getAttribute('action') || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { if (btn.disabled) return; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    markAdd();
    api('cart/add.js', new FormData(form))
      .then(refreshAndOpen)
      .catch(function (err) { return getCart().then(function (c) { render(c); open(); showError(err.message); }); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || root.contains(a) || a.hasAttribute('data-hc-ignore')) return;
    var href = a.getAttribute('href');
    var m = href.match(PERMALINK_RE);
    if (m) {
      e.preventDefault(); e.stopImmediatePropagation();
      var items = m[1].split(',').map(function (pair) { var x = pair.split(':'); return { id: Number(x[0]), quantity: Number(x[1]) }; });
      markAdd();
      addItems(items).then(refreshAndOpen).catch(function (err) { refreshAndOpen().then(function () { showError(err.message); }); });
      return;
    }
    if (/\/cart\/?(\?.*)?$/.test(href) || a.hasAttribute('data-hc-open')) {
      e.preventDefault();
      refreshAndOpen();
    }
  }, true);

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var internal = init && init.headers && (init.headers[INTERNAL] ||
      (typeof init.headers.get === 'function' && init.headers.get(INTERNAL)));
    var p = nativeFetch(input, init);
    if (!internal && CART_ADD_RE.test(url)) {
      markAdd();
      p.then(function (r) { if (r.ok) refreshAndOpen(); });
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_ADD_RE.test(String(url))) {
      markAdd();
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) refreshAndOpen(); });
    }
    return xOpen.apply(this, arguments);
  };

  if (window.navigation && window.navigation.addEventListener) {
    window.navigation.addEventListener('navigate', function (e) {
      try {
        var u = new URL(e.destination.url);
        if (/\/checkout(s)?(\/|$|\?)/.test(u.pathname) && Date.now() < recentAddUntil && e.cancelable) {
          e.preventDefault();
          refreshAndOpen();
        }
      } catch (err) {}
    });
  }

  window.HumeCart = {
    variant: VARIANT,
    open: refreshAndOpen,
    close: close,
    refresh: function () { return getCart().then(render); },
    add: function (items) { markAdd(); return addItems(items).then(refreshAndOpen); },
    rules: HumeCartRules,
    active: true
  };
  document.dispatchEvent(new CustomEvent('hume:cart:ready', { detail: { variant: VARIANT } }));

  getCart().then(render).catch(function () {});
  }
})();